<div class="campaign-banner" (click)="goToPromo()">
  <app-ds-rounded-icon
    icon="gift"
    variant="custom"
    customColor="var(--color-core-brand-1-5)"
    color="var(--color-core-neutral-0)"
  ></app-ds-rounded-icon>
  <div class="campaign-info">
    <h2 class="ds-heading-2">{{campaign.attributes.name}}</h2>
    <div class="ds-ui-3 ds-color-core-neutral-7">
      <app-remaining-time-label [start]="campaign.attributes.start_date" [end]="campaign.attributes.end_date"></app-remaining-time-label>
      {{ (campaign.attributes.opted_in ? 'PROMO.statusParticipating' : 'PROMO.mainOffer') | translate: { amount: highestAmount | thousand:
      currency } }}
    </div>
  </div>
  <ion-icon name="chevron-forward-outline"></ion-icon>
</div>
